module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Master2-e1509a88918dbbcdfebbb8996556d6a6.jpg";